import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                              from '@angular/core';
import { CONFIG_MODAL_CONFIG } from '@app/modules/configuration/config/show-config-modal-config';
import { ConfigTypeEnum }      from '@app/modules/configuration/models/configuration.model';
import { BaseComponent }       from '@core/bases/base-component/base.component';


@Component( {
	selector: 'app-setting-card',
	templateUrl: './setting-card.component.html',
	styleUrls: [ './setting-card.component.scss' ]
} )
export class SettingCardComponent extends BaseComponent implements OnInit {

	readonly configModes = CONFIG_MODAL_CONFIG.configModes;

	@Input() isExpanded = false;

	@Input() configMode: ConfigTypeEnum;

	@Input() hideSwitch = false;

	@Output() configModeSwitched: EventEmitter<ConfigTypeEnum> = new EventEmitter<ConfigTypeEnum>();

	expandSwitched: EventEmitter<boolean> = new EventEmitter<boolean>();


	constructor() {
		super();
	}

	ngOnInit() {}

	switchMode( mode: ConfigTypeEnum ) {
		this.configModeSwitched.emit( mode );
	}
}
